<template>
  <section class="principes px-md-10 px-4 pt-16">
    <PrincipesCardLayout
      class="mt-15"
      v-for="(card, index) in principlesData.slice(0, 2)"
      :key="index"
      :heading="card.heading"
      :subheading="card.subHeading"
    >
      <div class="cardContent">
        <PrincipesStage
          v-for="stage in card.content"
          :key="stage.title"
          :title="stage.title"
          :text="stage.text"
        />
      </div>
    </PrincipesCardLayout>

    <PrincipesCardLayout
      :heading="principlesData[2].heading"
      :subheading="principlesData[2].subHeading"
    >
      <div class="lastCardContent">
        <PrincipesStage
          v-for="stage in principlesData[2].content"
          :key="stage.title"
          :title="stage.title"
          :text="stage.text"
          :is-big="true"
        />
      </div>
    </PrincipesCardLayout>
  </section>
</template>

<script>
import PrincipesCardLayout from "@/components/principes/PrincipesCardLayout";
import PrincipesStage from "@/components/principes/PrincipesStage";
export default {
  name: "Principes",
  components: { PrincipesStage, PrincipesCardLayout },
  computed: {
    principlesData() {
      return this.$t("principles");
    }
  }
};
</script>

<style lang="sass" scoped>
@import "src/assets/style/vars"

.principes
  & > div
    margin-bottom: 200px
  @media (max-width: 600px)
    & > div
      margin-bottom: 80px

.cardContent
  width: 100%
  display: grid
  grid-template-columns: 333px 333px
  grid-column-gap: 176px
  grid-row-gap: 64px
  justify-content: center
  @media (max-width: 600px)
    grid-template-columns: 100%

.lastCardContent
  width: 650px
  margin: 0 auto
  & > div
    &:not(&:last-child)
      margin-bottom: 80px
  @media (max-width: 600px)
    width: 100%
</style>
